import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DS } from '../../components/ds';
import { BlogContextProvider } from '../../contexts/BlogContext';
import { ArticleList } from '../../components/sections/blog/ArticleList';
import { BlogBreadcrumb } from '../../components/sections/blog/BlogBreadcrumb';
import type { BlogArticle } from '../../data/blogArticles';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';
function BlogPageContent() {
  const navigate = useNavigate();
  useDocumentMeta({
    title: 'Blog | Alineadores invisibles y ortodoncia para clínicas',
    description: 'Artículos clínicos sobre alineadores invisibles, fabricación digital y mejores prácticas para odontólogos y ortodoncistas en Colombia.',
    path: '/blog'
  });
  const goToArticle = (article: BlogArticle) => {
    navigate(`/blog/${article.id}`);
  };
  return <section style={{
    background: '#fff',
    minHeight: '100vh',
    paddingTop: '68px'
  }} data-id="element-886" data-mp="27ptzvbub47uq">
      <BlogBreadcrumb items={[{
      label: 'Alinova',
      to: '/'
    }, {
      label: 'Blog'
    }]} data-id="element-887" data-mp="3a88c8nc39guc" />

      <div style={{
      position: 'relative',
      padding: '56px 24px',
      background: 'linear-gradient(135deg, rgba(0,170,212,0.08) 0%, rgba(45,212,212,0.05) 100%)',
      borderBottom: `1px solid ${DS.color.border}`,
      overflow: 'hidden'
    }} data-id="element-888" data-mp="3f0i0lyxk28ui">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative'
      }} data-id="element-889" data-mp="3t0sqozr1jjem">
          <button type="button" onClick={() => navigate('/')} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'transparent',
          border: 'none',
          padding: 0,
          marginBottom: '24px',
          color: DS.color.teal,
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer'
        }} data-id="element-890" data-mp="1sewwbthubev">
            <ArrowLeftIcon size={16} aria-hidden="true" data-id="element-891" data-mp="j4v5f865ctvk" />
            Volver al inicio
          </button>

          <h1 style={{
          fontFamily: DS.font.heading,
          fontSize: 'clamp(2.2rem, 5vw, 3rem)',
          fontWeight: 700,
          color: DS.color.ink,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          margin: '0 0 14px'
        }} data-id="element-892" data-mp="e61unni8vgz3">
            Alinova Blog
          </h1>
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '17px',
          color: DS.color.body,
          maxWidth: '520px',
          margin: 0
        }} data-id="element-893" data-mp="3rh0v4vmf3x1l">
            Conocimiento clínico, tendencias y mejores prácticas en
            ortodoncia invisible.
          </p>
        </div>
      </div>

      <div style={{
      padding: '56px 24px 80px'
    }} data-id="element-894" data-mp="1fst4ypd6tl97">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }} data-id="element-895" data-mp="1fqyhp4eg1h1y">
          <ArticleList onSelectArticle={goToArticle} data-id="element-896" data-mp="1o90fmbhihd5v" />
        </div>
      </div>
    </section>;
}
export function BlogPage() {
  return <BlogContextProvider data-id="element-897" data-mp="1s9khfsd154yc">
      <BlogPageContent data-id="element-898" data-mp="1x2ncy61daoh6" />
    </BlogContextProvider>;
}